import type { ReactNode } from 'react';
import { Button } from '@mui/material';

import { DASH } from '../tokens';

export interface GhostButtonProps {
  label: string;
  onClick?: () => void;
  endIcon?: ReactNode;
  startIcon?: ReactNode;
  ariaLabel?: string;
}

export function GhostButton({ label, onClick, endIcon, startIcon, ariaLabel }: GhostButtonProps) {
  return (
    <Button
      variant="text"
      disableRipple
      disabled={onClick === undefined}
      onClick={onClick}
      endIcon={endIcon}
      startIcon={startIcon}
      aria-label={ariaLabel}
      sx={{
        minWidth: 0,
        padding: 0,
        color: DASH.ghost,
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '32px',
        letterSpacing: '0.0313em',
        textTransform: 'none',
        '&.Mui-disabled': { color: DASH.ghost, opacity: 0.5 },
        '&:hover': { bgcolor: 'transparent' },
      }}
    >
      {label}
    </Button>
  );
}
